var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1218_5520)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.98 0C7.89922 0 5.43232 1.39643 3.63648 3.05848C1.85208 4.70536 0.658666 6.67857 0.0943674 8.03326C-0.0314558 8.33304 -0.0314558 8.66696 0.0943674 8.96674C0.658666 10.3214 1.85208 12.2946 3.63648 13.9415C5.43232 15.6036 7.89922 17 10.98 17C14.0607 17 16.5276 15.6036 18.3235 13.9415C20.1079 12.2908 21.3013 10.3214 21.8694 8.96674C21.9952 8.66696 21.9952 8.33304 21.8694 8.03326C21.3013 6.67857 20.1079 4.70536 18.3235 3.05848C16.5276 1.39643 14.0607 0 10.98 0ZM5.48951 8.5C5.48951 7.05078 6.06797 5.66092 7.09764 4.63617C8.1273 3.61141 9.52382 3.03571 10.98 3.03571C12.4361 3.03571 13.8327 3.61141 14.8623 4.63617C15.892 5.66092 16.4705 7.05078 16.4705 8.5C16.4705 9.94922 15.892 11.3391 14.8623 12.3638C13.8327 13.3886 12.4361 13.9643 10.98 13.9643C9.52382 13.9643 8.1273 13.3886 7.09764 12.3638C6.06797 11.3391 5.48951 9.94922 5.48951 8.5ZM10.98 6.07143C10.98 7.41094 9.8857 8.5 8.53977 8.5C8.26906 8.5 8.00979 8.45446 7.76577 8.37478C7.55607 8.30647 7.31205 8.43549 7.31967 8.65558C7.33111 8.91741 7.36924 9.17924 7.44168 9.44107C7.96404 11.3839 9.9734 12.5375 11.9256 12.0176C13.8777 11.4978 15.0368 9.49799 14.5145 7.55513C14.0912 5.98036 12.6919 4.92165 11.1363 4.85714C10.9152 4.84955 10.7855 5.08862 10.8542 5.30112C10.9342 5.54397 10.98 5.80201 10.98 6.07143Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1218_5520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.23df1e92d657b7479ea72f9efa8fc3d2.svg";
export { ForwardRef as ReactComponent };